<template>
  <div class="my-footer">
    <div class="w70">
      <div>
        <div><img src="./../static/鹏飞标志.png" alt=""></div>
        <div><img src="./../static/鹏飞集团.png" alt="" style="margin-top:25px;"></div>
      </div>
      <div>
        <div style="font-size: 22px;font-weight: 400;color: rgba(255, 255, 255, 1);">联系我们</div>
        <div class="us">邮箱：pfzb4@pengfeishiye.com</div>
        <div class="us">电话：0358-2883268</div>
        <div class="us">传真：0358-7826555</div>
        <div class="us">地址：山西省孝义市振兴街与中和路交叉口</div>
      </div>
      <div>
        <div style="font-size: 22px;font-weight: 700;color: rgba(255, 255, 255, 1);">监督通道</div>
        <div class="us">邮箱：pfzb3@pengfeishiye.com</div>
        <div class="us">监督人电话：14735882251</div>
      </div>
      <div>
        <div style="font-size: 22px;font-weight: 700;color: rgba(255, 255, 255, 1);">扫码关注公众号，获取更多咨询</div>
        <div style="display: flex;justify-content: space-around;margin-top: 38px;">
          <div style="display: flex;justify-content: center;flex-direction: column;align-items: center">
            <div><img src="./../static/pf.jpg" alt="官方微信公众号" style="width: 80px;height: 80px;"></div>
            <div style="font-size: 18px;color: #fff;margin-top: 10px;">官方微信公众号</div>
          </div>
          <div style="display: flex;justify-content: center;flex-direction: column;align-items: center">
            <div><img src="./../static/px2.jpg" alt="鹏飞招标部" style="width: 80px;height: 80px;"></div>
            <div style="font-size: 18px;color: #fff;margin-top: 10px;">鹏飞招标部</div>
          </div>
        </div>

      </div>
    </div>
    <div class="boot">
      <div>
        山西鹏飞集团有限公司
        <a href="https://beian.miit.gov.cn" target="_blank" style="color: #fff;text-decoration: none;margin-left: 10px;">晋ICP备2021017158号-1 </a>
        <img src="./../static/police.png" style="width: 28px;vertical-align: middle;margin-left:10px;margin-right:5px;" alt="">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=14118102000147" style="color: #fff;text-decoration: none;margin-left: 10px;">晋公网安备 14118102000147号</a>
      </div>
    </div>
  </div>
</template>
<script setup></script>
<style scoped>
.my-footer {
  width: 100%;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: rgba(77, 77, 77, 1);
}
.w70 {
  width: 1300px;
  display: flex;
  justify-content: space-between;
  padding: 60px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.us {
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  margin-top: 15px;
}
.boot {
  height: 80px;
  width: 100%;
  background: rgb(51, 51, 51);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(255, 255, 255, 1);
}
</style>